import { render } from "./additemsmovement.vue?vue&type=template&id=dbb83080&scoped=true"
import script from "./additemsmovement.vue?vue&type=script&lang=js"
export * from "./additemsmovement.vue?vue&type=script&lang=js"

import "./additemsmovement.vue?vue&type=style&index=0&id=dbb83080&scoped=true&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/levelup/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbb83080"]])

export default __exports__